"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Description = void 0;

var _cssInJs = require("@compiled/css-in-js");

var _react = _interopRequireDefault(require("react"));

var _this = void 0,
    _jsxFileName = "/home/ackwell/code/xivanalysis/tooltips/src/ui/description.tsx";

var Description = function Description(_ref) {
  var html = _ref.html;
  return /*#__PURE__*/_react["default"].createElement(_cssInJs.CC, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 3,
      columnNumber: 43
    }
  }, /*#__PURE__*/_react["default"].createElement(_cssInJs.CS, {
    hash: "1c5njky",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 3,
      columnNumber: 47
    }
  }, [".cc-1c5njky{margin:0;border-top:1px solid #111;padding:8px;background:#222;font-size:11px}"]), /*#__PURE__*/_react["default"].createElement("p", {
    dangerouslySetInnerHTML: {
      // TODO: Pull in my description parser for this bullshit?
      __html: html.replace(/(\n|<br ?\/?>)+/g, '<br/>')
    },
    className: "cc-1c5njky",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 3,
      columnNumber: 167
    }
  }));
};

exports.Description = Description;